import React from 'react';
import { useApiHolder } from '@backstage/frontend-plugin-api';
import {
  NotificationsSidebarItem,
  notificationsApiRef,
} from '@backstage/plugin-notifications';

/**
 * Renders <NotificationsSidebarItem /> only when the notifications plugin API
 * is registered; renders nothing otherwise.
 *
 * The notifications plugin is wired in Phase 5d; before that its apiRef is
 * absent from the registry. Calling useApi() when absent throws
 * NotImplementedError, which in dev mode also triggers the rspack error
 * overlay, masking page content and causing false E2E failures.
 *
 * Using useApiHolder().get() returns undefined instead of throwing, so the
 * overlay is never triggered. This guard can remain in place after Phase 5d
 * (it is harmless once the API is registered) or be removed at that point.
 */
export const SafeNotificationsSidebarItem = (): React.ReactElement | null => {
  const apiHolder = useApiHolder();
  const api = apiHolder.get(notificationsApiRef);

  if (!api) {
    return null;
  }

  return <NotificationsSidebarItem />;
};
